<template>
  <v-btn
    depressed
    color="primary"
    height="52"
    :href="href"
    :block="isMobile"
    class="branding-btn branding-btn--primary rounded-20 text-none text-subtitle-1"
  >
    {{ label }}
  </v-btn>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import useIsMobile from 'src/composables/useIsMobile'
import tStatic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tStatic'

defineProps<{
  href: string
}>()

const isMobile = useIsMobile()
const label = computed(() => (
  isMobile.value
    ? tStatic('Показать все цены')
    : tStatic('Показать все')
))
</script>
